<script setup lang="ts" generic="T extends SelectableValue">
import FormMultiComboboxInput, {
  FormMultiComboboxProps
} from '@/components/formComboboxInput/FormMultiComboboxInput.vue';
import { Selectable, SelectableValue } from '@/components/selectBox/selectBox';
import { useScholarshipsSearch } from '@/hooks/search/useScholarshipsSearch';

const props = defineProps<Omit<FormMultiComboboxProps<number>, 'options' | 'searchable'>>();

defineEmits<{
  'update:modelValue': [Selectable<number>[]];
}>();

const { scholarshipOptions, isLoading, onQueryChange } = useScholarshipsSearch(props.searchFilters);
</script>

<template>
  <FormMultiComboboxInput
    v-bind="$props"
    showQueryAsOption
    :isLoading="isLoading"
    :options="scholarshipOptions"
    :onFilter="onQueryChange"
    @update:modelValue="(value) => $emit('update:modelValue', value)"
    @open="() => onQueryChange('')"
  />
</template>
